import React from 'react';

import getFlattenNodes from '../getFlattenNodes';
import reducer, {
  RESET_STATE,
  ADD_NODE,
  REMOVE_NODE,
  UPDATE,
  RESET_BUDGET,
  SET_FIELD_VALUE,
  APPLY_METRIC_BELLOW,
} from '../reducer';

export const usePlanState = ({ initialValues, onSaveState }) => {
  const callback = React.useCallback((state, action) => {
    const newState = reducer(state, action);

    if (action.shouldSave) {
      const nodes = getFlattenNodes(newState, action);
      onSaveState(nodes);
    }
    return newState;
  }, []);

  const [values, dispatch] = React.useReducer(callback, initialValues);

  React.useEffect(() => {
    dispatch({
      type: RESET_STATE,
      payload: initialValues,
    });
  }, [initialValues]);

  const handleAddNode = ({ parentId, nodes }) => {
    //add to parentId
    dispatch({
      type: ADD_NODE,
      payload: { parentId, nodes },
      shouldSave: false,
    });
  };

  const handleRemoveNode = ({ nodeId }) => {
    dispatch({
      type: REMOVE_NODE,
      payload: nodeId,
      shouldSave: false,
    });
  };

  const handleUpdateNode = ({ data }) => {
    dispatch({
      type: UPDATE,
      payload: { nodes: data },
      shouldSave: false,
    });
  };

  const handleChangeField = ({ levelPath, name, value }) => {
    dispatch({
      type: SET_FIELD_VALUE,
      payload: { levelPath, name, value },
      shouldSave: true,
    });
  };

  const handleResetBudget = ({ levelPath, activityType }) => {
    dispatch({
      type: RESET_BUDGET,
      payload: { levelPath, activityType },
      shouldSave: true,
    });
  };

  const handleApplyMetricBellow = ({
    levelPath,
    activityType,
    metric,
    value,
  }) => {
    dispatch({
      type: APPLY_METRIC_BELLOW,
      payload: { levelPath, activityType, metric, value },
      shouldSave: true,
    });
  };

  return [
    values,
    {
      onChangeField: handleChangeField,
      onAddNode: handleAddNode,
      onRemoveNode: handleRemoveNode,
      onUpdateNode: handleUpdateNode,
      onResetBudget: handleResetBudget,
      onApplyMetricBellow: handleApplyMetricBellow,
    },
  ];
};
